import { shadowRoot } from "./_dom-context";

export class AddAnother {
	constructor(container) {
		this.container =
			typeof container === "string"
				? shadowRoot.querySelector(container)
				: container;

		if (this.container.dataset.initialized) return;
		this.container.dataset.initialized = "true";

		this.container.addEventListener("click", (e) => {
			// The remove buttons are generated dynamically, but event delegation still catches them perfectly
			if (e.target.closest(".fn-button-unstyled")) {
				this.onRemoveButtonClick(e);
			} else if (e.target.closest('button[data-variant="secondary"]')) {
				this.onAddButtonClick(e);
			}
		});
	}

	onAddButtonClick() {
		const currentItems = this.getItems();
		const item = this.getNewItem();

		this.updateAttributes(currentItems.length, item);
		this.resetItem(item);

		// If there is only 1 item currently, it doesn't have a remove button yet. Add it.
		if (currentItems.length === 1) {
			this.createRemoveButton(currentItems[0]);
		}

		// Ensure the newly cloned item gets a remove button too
		this.createRemoveButton(item);

		const lastItem = currentItems[currentItems.length - 1];
		lastItem.after(item);

		const firstInput = item.querySelector("input, textarea, select");
		if (firstInput) {
			firstInput.focus();
		}
	}

	getItems() {
		return Array.from(
			this.container.querySelectorAll(".fn-add-group:not(:last-child)"),
		);
	}

	getNewItem() {
		const items = this.getItems();
		return items[0].cloneNode(true);
	}

	createRemoveButton(item) {
		// Check if it already has a remove button so we don't accidentally add two
		if (!item.querySelector(".fn-button-unstyled")) {
			item.insertAdjacentHTML(
				"beforeend",
				'<button class="fn-button-unstyled" type="button">Remove</button>',
			);
		}
	}

	updateAttributes(index, item) {
		item.querySelectorAll("input, textarea, select").forEach((el) => {
			if (el.name) {
				el.name = el.name.replace(/\[\d+\]/, `[${index}]`);
			}
			if (el.id) {
				el.id = el.id.replace(/\d+$/, index);
			}

			const label = item.querySelector("label");
			if (label?.htmlFor) {
				label.htmlFor = label.htmlFor.replace(/\d+$/, index);
			}
		});
	}

	resetItem(item) {
		// 1. Reset input values
		item.querySelectorAll("input, textarea, select").forEach((el) => {
			if (el.type === "checkbox" || el.type === "radio") {
				el.checked = false;
			} else {
				el.value = "";
			}

			// Strip error attributes from the inputs
			el.removeAttribute("aria-invalid");
			el.removeAttribute("aria-describedby");
			el.removeAttribute("data-has-error");
		});

		// 2. Remove the injected error spans
		item.querySelectorAll(".fn-error").forEach((err) => {
			err.remove();
		});

		// 3. Strip error attributes from fieldsets or containers
		item.querySelectorAll("[aria-invalid]").forEach((el) => {
			el.removeAttribute("aria-invalid");
		});
		item.querySelectorAll("[data-has-error]").forEach((el) => {
			el.removeAttribute("data-has-error");
		});
	}

	onRemoveButtonClick(e) {
		const itemToRemove = e.target.closest(".fn-add-group");
		const itemsBeforeRemoval = this.getItems();

		if (itemsBeforeRemoval.length > 1 && itemToRemove) {
			itemToRemove.remove();
		}

		const remainingItems = this.getItems();

		// If we are back down to exactly 1 item, strip out its remove button
		if (remainingItems.length === 1) {
			const removeBtn = remainingItems[0].querySelector(".fn-button-unstyled");
			if (removeBtn) {
				removeBtn.remove();
			}
		}

		// Re-index remaining elements
		remainingItems.forEach((el, index) => {
			this.updateAttributes(index, el);
		});

		this.focusHeading();
	}

	focusHeading() {
		const heading = shadowRoot.querySelector("h2");
		if (heading) {
			heading.focus();
		}
	}
}
